import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { FraudPage } from "@/components/admin/aml/FraudPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/fraud")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="fraud">
      <FraudPage />
    </AdminShell>
  ),
});
